var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkIcon = function SvgCheckmarkIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6668 6.5L7.00016 10.1667L5.3335 8.5",
    stroke: "#979998",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.99949 1.77202C4.55876 1.77203 1.76949 4.56129 1.76949 8.00203C1.76949 11.4428 4.55876 14.232 7.99949 14.232C11.4402 14.232 14.2295 11.4428 14.2295 8.00202C14.2295 4.56129 11.4402 1.77202 7.99949 1.77202Z",
    stroke: "#979998",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgCheckmarkIcon;